import template from './sw-cms-el-config-acris-faq.html.twig';

const { Component, Mixin } = Shopware;

const { EntityCollection, Criteria } = Shopware.Data;

Component.register('sw-cms-el-config-acris-faq', {
    template,

    mixins: [
        Mixin.getByName('cms-element')
    ],

    inject: ['repositoryFactory'],

    computed: {
        faqGroupCriteria() {
            const criteria = new Criteria();
            criteria.addAssociation('faqs');
            return criteria;
        },

        faqGroup() {
            return this.repositoryFactory.create('acris_faq_group');
        },

        optionsGroupLoaded() {
            return [
                { value: "manual", label: this.$tc('acris-faq.elements.faqGroups.config.label.groupLoadedOptionManual') },
                { value: "categories", label: this.$tc('acris-faq.elements.faqGroups.config.label.groupLoadedOptionCategories') },
                { value: "products", label: this.$tc('acris-faq.elements.faqGroups.config.label.groupLoadedOptionProducts') },
            ];
        },
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-faq');

            if (this.element.config.faqGroups.value.length === 0) {
                this.element.config.faqGroups.value = this.createFaqGroupCollection();
            } else {
                const emptyFaqGroup = this.createFaqGroupCollection();
                this.element.config.faqGroups.value.forEach((value) => {
                    emptyFaqGroup.add(value);
                });

                this.element.config.faqGroups.value = emptyFaqGroup;
            }
        },

        createFaqGroupCollection() {
            return new EntityCollection('/acris_faq_group', 'acris_faq_group', Shopware.Context.api, new Criteria());
        }
    }

});
